import { render, staticRenderFns } from "./GAG.pug?vue&type=template&id=69472f2c&lang=pug&"
import script from "./GAG.js?vue&type=script&lang=js&"
export * from "./GAG.js?vue&type=script&lang=js&"
import style0 from "./GAG.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69472f2c')) {
      api.createRecord('69472f2c', component.options)
    } else {
      api.reload('69472f2c', component.options)
    }
    module.hot.accept("./GAG.pug?vue&type=template&id=69472f2c&lang=pug&", function () {
      api.rerender('69472f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/views/GAG/index.vue"
export default component.exports